"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsNotXssVulnerability = exports.checkXssVulnerability = void 0;
var xss = __importStar(require("xss"));
var class_validator_1 = require("class-validator");
function checkXssVulnerability(str, options) {
    var _a, _b;
    var allowList = __assign(__assign({}, ((_a = options === null || options === void 0 ? void 0 : options.allowList) !== null && _a !== void 0 ? _a : {})), ((_b = options === null || options === void 0 ? void 0 : options.whiteList) !== null && _b !== void 0 ? _b : {}));
    var xssOptions = __assign(__assign({}, options), { allowList: allowList, whiteList: allowList, onIgnoreTag: function (tag, html, opts) {
            var _a;
            (_a = options === null || options === void 0 ? void 0 : options.onIgnoreTag) === null || _a === void 0 ? void 0 : _a.call(options, tag, html, opts);
            if (opts.isWhite) {
                return tag;
            }
            if (!(options === null || options === void 0 ? void 0 : options.disableThrowOnIgnoreTag)) {
                throw new Error("Possible xss detected: ".concat(str));
            }
        }, onIgnoreTagAttr: function (tag, name, value, isWhiteAttr) {
            var _a;
            (_a = options === null || options === void 0 ? void 0 : options.onIgnoreTagAttr) === null || _a === void 0 ? void 0 : _a.call(options, tag, name, value, isWhiteAttr);
            if (isWhiteAttr) {
                return value;
            }
            if (!(options === null || options === void 0 ? void 0 : options.disableThrowOnIgnoreTagAttr)) {
                throw new Error("Possible xss detected: ".concat(str));
            }
        } });
    xss.filterXSS(str, xssOptions);
    var decodedStr = null;
    try {
        decodedStr = decodeURIComponent(str);
    }
    catch (_c) { }
    if (decodedStr) {
        xss.filterXSS(decodeURIComponent(str), xssOptions);
    }
}
exports.checkXssVulnerability = checkXssVulnerability;
function IsNotXssVulnerability(options) {
    return function (obj, propertyName) {
        (0, class_validator_1.registerDecorator)({
            name: 'isXssVulnerability',
            target: obj.constructor,
            propertyName: propertyName,
            constraints: [],
            options: __assign({ message: "".concat(propertyName, " may not contain HTML tags") }, options),
            validator: {
                validate: function (value, _args) {
                    var valid = true;
                    try {
                        checkXssVulnerability(value);
                    }
                    catch (_a) {
                        valid = false;
                    }
                    return valid;
                },
            },
        });
    };
}
exports.IsNotXssVulnerability = IsNotXssVulnerability;
//# sourceMappingURL=is-not-xss-vulnerability.js.map